.ticker { height: 34px; overflow: hidden; display: flex; align-items: center; background: var(--pink); border-bottom: 1px solid var(--ink); padding: 0 var(--page-x); }
.tickerTrack { display: flex; gap: 28px; white-space: nowrap; animation: ticker 40s linear infinite; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; }
@keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }
@media (hover: hover) { .ticker:hover .tickerTrack { animation-play-state: paused; } }
.header { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 28px; }
.headlineNote { margin: 0; max-width: 60ch; font-size: 15px; line-height: 1.45; color: var(--text-secondary); }
.strip { display: flex; margin: 0; padding: 18px 6px; background: var(--ink); }
.stripCell { display: flex; flex-direction: column; gap: 2px; padding: 0 22px; border-right: 1px solid var(--paper-13); }
.stripCell:last-child { border-right: 0; }
.stripLabel { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; color: var(--pink); }
.stripValue { margin: 0; font-family: var(--font-cond); font-size: 52px; font-weight: 900; letter-spacing: -1.5px; color: var(--paper); line-height: 1; }
.stripValue[data-zone='fresh'] { color: var(--green); }
.stripValue[data-zone='productive'] { color: var(--amber); }
.stripValue[data-zone='overreaching'] { color: var(--hot); }
.stripNote { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--paper-60); }
/* Two classes: .alert-amber loads after this module and would set 16px side padding on phones; this banner kept 24px. */
@media (max-width: 639px) { :global(.alert-amber).banner { padding: 12px 24px; } }
.banner a { text-decoration: underline; }
.panel { display: flex; flex-direction: column; gap: 18px; padding: 28px; background: var(--paper); border: var(--border-panel); box-shadow: var(--shadow-panel); }
.chartHeader { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 18px 24px; }
.chartHeadLeft { display: flex; flex-direction: column; gap: 4px; }
.chartEyebrow { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.5px; color: var(--text-secondary); }
.chartTitle { margin: 0; font-family: var(--font-cond); font-size: 40px; font-weight: 800; letter-spacing: -1.5px; line-height: 1; }
.controls { display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-end; gap: 14px 24px; }
.peakRow { display: flex; align-items: center; }
.peak { padding: 7px 12px; background: var(--hot); border: 2px solid var(--ink); font-family: var(--font-cond); font-size: 18px; font-weight: 900; letter-spacing: 0.5px; color: var(--paper); }
.peak:empty { display: none; }
.todayNote { display: none; }
.legend { display: flex; gap: 18px; margin: 0; padding: 0; list-style: none; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; }
.legend li { display: flex; align-items: center; gap: 7px; }
.swatch { display: inline-block; width: 18px; height: 3px; background: var(--ink); }
.swatch[data-series='fatigue'] { height: 2px; background: var(--hot); }
.swatch[data-series='form'] { height: 1.5px; }
.swatch[data-series='load'] { width: 8px; height: 8px; background: var(--pink); }
.sportStack { display: inline-flex; flex-direction: column; gap: 1px; }
.sportStack > span { width: 8px; height: 3px; }
.swatch[data-series='planned'] { width: 21px; height: 2px; background: repeating-linear-gradient(90deg, var(--ink) 0 5px, transparent 5px 8px); }
.projection { margin: 0; padding: 12px 0 0 48px; border-top: var(--border-hair); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.chartWrap { position: relative; }
.zoneKey { display: none; }
.hint { display: none; }
.emptyActions { display: flex; flex-wrap: wrap; gap: 12px; }
.lower { display: flex; gap: 28px; align-items: flex-start; }
/* Fluid between 340px and 440px (full at 1280px) instead of an extra breakpoint. */
.side { width: clamp(340px, 34.4vw, 440px); flex: none; display: flex; flex-direction: column; gap: 28px; }
.latest { flex: 1; min-width: 0; background: var(--paper); border: var(--border-hair); }
.darkLink { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--pink); white-space: nowrap; }
.table th:first-child, .table td:first-child { padding-left: 22px; width: 80px; }
.table th:nth-child(2), .table td:nth-child(2) { width: 112px; }
.table th:nth-child(4), .table td:nth-child(4) { width: 60px; }
.table th:nth-child(5), .table td:nth-child(5) { width: 80px; }
.table th:nth-child(6), .table td:nth-child(6) { width: 150px; padding-right: 22px; }
/* (0,2,1): beats .data-table td, which global.css loads after this module. */
.latest .table td { padding-top: 15px; padding-bottom: 15px; }
.table td[data-cell='chevron'] { display: none; }
.rideName { font-family: var(--font-cond); font-size: 20px; font-weight: 800; }
.rideMeta { display: none; }
.importCard { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; padding: 22px; background: var(--paper-2); border: var(--border-panel); }
.importCard[data-tone='revoked'] { background: var(--hot-8); border-color: var(--hot); }
.importHead { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.importTitle { margin: 0; font-family: var(--font-cond); font-size: 22px; font-weight: 800; }
.importCount { font-family: var(--font-mono); font-size: 11px; }
.track { width: 100%; height: 10px; background: var(--paper); border: 1px solid var(--ink); }
.trackFill { display: block; height: 100%; background: var(--amber); }
.importNote { margin: 0; font-size: 12px; line-height: 1.5; color: var(--text-secondary); }

@media (max-width: 1023px) {
  .lower { flex-direction: column; align-items: stretch; }
  .side { width: auto; }
}

@media (max-width: 639px) {
  .ticker { height: 30px; }
  .tickerTrack { gap: 22px; }
  .header { display: grid; grid-template-areas: 'left' 'strip'; gap: 24px; }
  .headerLeft { grid-area: left; }
  .strip { grid-area: strip; padding: 14px 0; }
  .stripCell { flex: 1 1 0; min-width: 0; padding: 0 14px; }
  .stripValue { font-size: 44px; }
  .panel { gap: 14px; padding: 14px; box-shadow: 4px 4px 0 var(--ink); }
  .chartHeader { flex-direction: column; align-items: stretch; gap: 14px; }
  .chartEyebrow { letter-spacing: 1.4px; }
  .chartTitle { font-size: 30px; letter-spacing: -1px; }
  .controls { flex-direction: column; align-items: stretch; gap: 14px; }
  .rangeTabs { order: 1; }
  .legend { order: 2; justify-content: space-between; gap: 0; letter-spacing: 1px; }
  .legend li { gap: 6px; }
  .swatch { width: 14px; }
  .swatch[data-series='form'] { height: 2px; }
  .swatch[data-series='load'] { width: 8px; }
  .projection { padding-left: 0; }
  .peakRow { order: 3; justify-content: space-between; gap: 12px; }
  .peak { padding: 5px 10px; font-size: 16px; }
  .todayNote { display: inline; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
  .zoneKey { position: absolute; left: 30px; right: 8px; display: flex; flex-wrap: wrap; gap: 6px 12px; margin: 0; padding: 0; list-style: none; font-family: var(--font-mono); font-size: 8px; line-height: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
  .zoneKey li { display: flex; align-items: center; gap: 5px; }
  .zoneSwatch { width: 10px; height: 10px; flex: none; }
  .zoneSwatch[data-zone='neutral'] { border: 1px solid var(--ink); }
  .hint { display: flex; align-items: center; gap: 6px; margin: 0; padding-top: 10px; border-top: var(--border-hair); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
  .side { gap: 24px; }
  .darkLink { display: inline-flex; align-items: center; min-height: 44px; margin: -10px 0; }
  .table tr { position: relative; display: grid; grid-template-columns: 1fr 76px 14px; grid-template-areas: 'ride load chevron'; align-items: center; column-gap: 12px; min-height: 64px; padding: 0 16px; border-bottom: var(--border-hair); }
  .table td[data-cell] { width: auto; padding: 0; border-bottom: 0; }
  .table td[data-cell='date'], .table td[data-cell='sport'], .table td[data-cell='how'], .table td[data-cell='time'] { display: none; }
  .table td[data-cell='ride'] { grid-area: ride; display: flex; flex-direction: column; gap: 3px; min-width: 0; }
  .table td[data-cell='load'] { grid-area: load; justify-self: end; }
  .table td[data-cell='chevron'] { grid-area: chevron; display: flex; color: var(--text-secondary); }
  .rideName { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .rideName::after { content: ''; position: absolute; inset: 0; }
  .rideMeta { display: block; font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.6px; color: var(--text-secondary); }
  .importCard { padding: 18px; }
}
